export { default } from 'esm-require-directory';
